/* Le dictionnaire français, assemblé. Ne pas éditer : chaque écran a son fichier. */
import { commun } from './commun';
import { app } from './app';
import { menu } from './menu';
import { ui } from './ui';
import { connexion } from './connexion';
import { taches } from './taches';
import { disponibilites } from './disponibilites';
import { planning } from './planning';
import { locations } from './locations';
import { contrats } from './contrats';
import { nouvelleReservation } from './nouvelleReservation';
import { reservation } from './reservation';
import { etatDesLieux } from './etatDesLieux';
import { caisse } from './caisse';
import { caisseVehicule } from './caisseVehicule';
import { caisseExtra } from './caisseExtra';
import { depenses } from './depenses';
import { banque } from './banque';
import { dettes } from './dettes';
import { capacite } from './capacite';
import { analytique } from './analytique';
import { flotte } from './flotte';
import { entretien } from './entretien';
import { echeances } from './echeances';
import { assurances } from './assurances';
import { amendes } from './amendes';
import { sinistres } from './sinistres';
import { clients } from './clients';
import { corrections } from './corrections';
import { cautions } from './cautions';
import { factures } from './factures';
import { journal } from './journal';
import { notes } from './notes';
import { parametres } from './parametres';
import { utilisateurs } from './utilisateurs';
import { suppression } from './suppression';
import { aide } from './aide';
import { plus } from './plus';
import { decalageEncaissement } from './decalageEncaissement';
import { fileHorsLigne } from './fileHorsLigne';
import { filet } from './filet';
import { formulaireClient } from './formulaireClient';
import { motDePasse } from './motDePasse';
import { photosEdl } from './photosEdl';
import { releveKm } from './releveKm';
import { schemaVoiture } from './schemaVoiture';
import { alertes } from './alertes';
import { auth } from './auth';
import { demo } from './demo';

export const fr = {
  commun,
  app,
  menu,
  ui,
  connexion,
  taches,
  disponibilites,
  planning,
  locations,
  contrats,
  nouvelleReservation,
  reservation,
  etatDesLieux,
  caisse,
  caisseVehicule,
  caisseExtra,
  depenses,
  banque,
  dettes,
  capacite,
  analytique,
  flotte,
  entretien,
  echeances,
  assurances,
  amendes,
  sinistres,
  clients,
  corrections,
  cautions,
  factures,
  journal,
  notes,
  parametres,
  utilisateurs,
  suppression,
  aide,
  plus,
  decalageEncaissement,
  fileHorsLigne,
  filet,
  formulaireClient,
  motDePasse,
  photosEdl,
  releveKm,
  schemaVoiture,
  alertes,
  auth,
  demo,
};
